"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearCache = ClearCache;
exports.CacheObservable = CacheObservable;
const core_1 = require("@athena-portal/core");
const Types_1 = require("../Types");
const operators_1 = require("rxjs/operators");
/**
 * Decorator for clearing cache.
 *
 * Clear all items by identified by key prefix.
 *
 * @key     Cache key used to identify value.
 * @storage (Optional)Storage of cache.
 */
function ClearCache(key, storage) {
    return function (target, propertyKey, descriptor) {
        const method = descriptor.value;
        descriptor.value = function (...args) {
            core_1.iocContainer
                .get(Types_1.Types.CacheManager)
                .clearCache(key, storage);
            return method.apply(this, args);
        };
    };
}
/**
 * Decorator for caching observable.
 *
 * @secure        (Optional)Weather or not to use encryption. Requires application guard.
 * @key           (Optional)Default key override. Default is method name.
 * @timeToLiveSec (Optional)Default time to live override.
 * @storage       (Optional)Default storage override..
 */
function CacheObservable(secure, key, timeToLiveSec, storage) {
    const useEncryption = secure ? true : false;
    return function (target, propertyKey, descriptor) {
        const method = descriptor.value;
        descriptor.value = function (...args) {
            const cacheManager = core_1.iocContainer.get(Types_1.Types.CacheManager);
            const cacheKey = key || propertyKey + args.toString();
            if (cacheManager.isCached(cacheKey, storage)) {
                const cachedValue = cacheManager.tryGetObservable(cacheKey, storage);
                if (cachedValue != null) {
                    return cachedValue;
                }
            }
            const result = method.apply(this, args).pipe((0, operators_1.share)());
            cacheManager.saveObservable(cacheKey, result, useEncryption, storage, timeToLiveSec);
            return result;
        };
    };
}
//# sourceMappingURL=Cache.js.map